import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container card col-md-8" }
const _hoisted_2 = { class: "loading-content d-flex align-items-center justify-content-center" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ThePageHeader, { pageTitle: _ctx.title }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ProgressSpinner, {
          class: "ps-2 align-items-center",
          style: {"width":"50px","height":"50px"}
        })
      ])
    ])
  ]))
}